import consumer from "./consumer"

consumer.subscriptions.create("FolderStatusChannel", {
  received(data) {
    const { folder_id, verification_status, remove_dnc_status, merge_status } = data;

    // Update verification percentage text (during verifying)
    if (data.verify_progress) {
      const { percentage } = data.verify_progress;
      const statusEl = document.querySelector(`.verifying-status-${folder_id}`);
      if (statusEl) statusEl.textContent = `${percentage}%`;
      return;
    }
    // Update Verification Status Badge
    const verificationBadge = document.querySelector(`.index-verification-status-${folder_id}`);
    if (verificationBadge && verification_status !== undefined) {
      const verificationKlass = verification_status === "Verified" ? "badge-dnc" : "badge-red";
      verificationBadge.textContent = verification_status;
      verificationBadge.className = `status-badge mb-1 p-1 text-center index-verification-status-${folder_id} ${verificationKlass}`
    }

    // Update DNC Status Badge
    const dncBadge = document.querySelector(`.index-dnc-status-${folder_id}`);
    if (dncBadge && remove_dnc_status !== undefined) {
      const label = getDncStatusLabel(remove_dnc_status);
      const klass = getDncLabelKlass(label);
      dncBadge.textContent = label;
      dncBadge.className = `status-badge mb-0 p-1 text-center index-dnc-status-${folder_id}
        ${klass}`;
    }

    // Update merging status
    const mergebadge = document.querySelector(`.merging-status-${folder_id}`);
    if (mergebadge && merge_status !== undefined) {
      mergebadge.textContent = merge_status;
      mergebadge.className = `merging-status-${folder_id}`;
    }

    // Re-render upload tab action button when upload completes
    if (data.upload_action_btn_html) {
      const uploadBtn = document.querySelector(`#upload-action-btn-${folder_id}`);
      if (uploadBtn) uploadBtn.outerHTML = data.upload_action_btn_html;
    }

    // Update tab step grey/blue state when any step completes
    if (data.tab_completion) {
      const { upload, merge, dnc, verify } = data.tab_completion;
      const toggleTab = (target, done) => {
        const btn = document.querySelector(`[data-bs-target="${target}"]`);
        if (btn) btn.classList.toggle('tab-pending', !done);
      };
      toggleTab(`#tabUpload${folder_id}`, upload);
      toggleTab(`#tabMerge${folder_id}`, merge);
      toggleTab(`#tabRemove${folder_id}`, dnc);
      toggleTab(`#tabVerify${folder_id}`, verify);
      toggleTab(`#tabCompliant${folder_id}`, verify);
    }

    // Re-render Merge tab when merge completes
    if (data.merge_tab_html) {
      const mergeTabPanel = document.querySelector(`#tabMerge${folder_id}`);
      if (mergeTabPanel) mergeTabPanel.innerHTML = data.merge_tab_html;
    }

    // Re-render Remove DNC tab when removal completes
    if (data.remove_tab_html) {
      const removeTabPanel = document.querySelector(`#tabRemove${folder_id}`);
      if (removeTabPanel) removeTabPanel.innerHTML = data.remove_tab_html;
    }

    // Re-render Verify tab and switch to it when verification completes
    if (data.verify_tab_html) {
      const verifyTabPanel = document.querySelector(`#tabVerify${folder_id}`);
      if (verifyTabPanel) verifyTabPanel.innerHTML = data.verify_tab_html;
      const verifyTabTrigger = document.querySelector(`[data-bs-target="#tabVerify${folder_id}"]`);
      if (verifyTabTrigger) {
        new bootstrap.Tab(verifyTabTrigger).show();
      } else {
        const compliantTabTrigger = document.querySelector(`[data-bs-target="#tabCompliant${folder_id}"]`);
        if (compliantTabTrigger) new bootstrap.Tab(compliantTabTrigger).show();
      }
    }
  }
});

function getDncStatusLabel(status) {
  switch (status) {
    case "Not Removed":
      return "DNC Pending";
    case "Removing":
      return "DNC Filtering";
    case "Removed":
      return "DNC Filtered";
    case "Partially Removed":
      return "Partially DNC Filtered";
    default:
      return status;
  }
}

function getDncLabelKlass(label) {
  switch (label) {
    case "DNC Filtered":
      return "badge-dnc";
    default:
      return "badge-red";
  }
}



